export default function checkIfSeatCountValid(seatCount) {
  return seatCount > 1
}
